import { Component, HostListener, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from './services/local-storage.service';
import { AuthService } from './services/auth.service';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  @HostListener('contextmenu', ['$event'])
  onRightClick(event: Event) {
    if (environment.production) {
      event.preventDefault();
    }
  }

  constructor(
    private readonly _localStorageService: LocalStorageService,
    private readonly _authService: AuthService
  ) {
    if (!this._localStorageService.machineId) {
      this._localStorageService.machineId = uuidv4();
    }
  }

  ngOnInit() {
    const loggedOut =
      typeof window !== 'undefined' &&
      /(?:^|[?&])loggedOut=1(?:&|$)/.test(window.location.search);
    const onLogoutRoute =
      typeof window !== 'undefined' &&
      /\/logout(?:\?|$|\/)/.test(window.location.pathname);
    if (loggedOut || this._authService.wasSignedOutLocally() || onLogoutRoute) {
      console.log('[he-auth][periodic-refresh] wa-account-v2: timer not started', {
        loggedOut,
        signedOutLocally: this._authService.wasSignedOutLocally(),
        onLogoutRoute,
      });
      return;
    }
    void this._authService.ensureValidAccessToken();
    this._authService.startPeriodicSessionRefresh();
  }
}
